import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchMostWatched } from './queryFunctions';
import { createMostWatchedQueryOptions } from './queryOptions';

type FetchMostWatchedArgs = {
  userId: string;
};

export function fetchMostWatchedQuery({ userId }: FetchMostWatchedArgs) {
  return queryClient.fetchQuery(createMostWatchedQueryOptions({ userId }));
}

export function prefetchMostWatchedQuery({ userId }: FetchMostWatchedArgs) {
  return queryClient.prefetchQuery(createMostWatchedQueryOptions({ userId }));
}

export function getMostWatchedQueryData() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchMostWatched>>>(queryKeys.mostWatched);
}
